// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.ChevronUp = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ChevronUp = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var ChevronUp = _exports.ChevronUp = function ChevronUp(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M15.4195 12.8723C15.2709 12.8723 15.1222 12.8159 15.0092 12.702L10.0004 7.69296L4.99154 12.702C4.76471 12.9289 4.39695 12.9289 4.17012 12.702C3.94329 12.4752 3.94329 12.1074 4.17012 11.8806L9.58929 6.46115C9.81612 6.23431 10.1839 6.23431 10.4107 6.46115L15.8299 11.8806C16.0567 12.1074 16.0567 12.4752 15.8299 12.702C15.7168 12.8159 15.5682 12.8723 15.4195 12.8723Z",
      fill: "#212B36"
    }));
  };
});
